import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import VehicleAccess from './VehicleAccess';
import { actions as signalsActions } from '../../../../../../services/signals/reducers';
import { actions as configurationActions } from '../../reducers';

function mapStateToProps(state) {
  return {
    signals: state.signals.signals,
    selectedVehicleAccess: state.configuration.selectedVehicleAccess,
    publishedVehicleAccess: state.configuration.connectConfig.vehicleAccess,
  };
}

function mapDispatchToProps(dispatch) {
  const {
    fetchSignalsRequest,
  } = signalsActions;
  const {
    initializeSelectedVehicleAccess,
    setSelectedVehicleAccess,
  } = configurationActions;

  return {
    actions: bindActionCreators({
      fetchSignalsRequest,
      initializeSelectedVehicleAccess,
      setSelectedVehicleAccess,
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleAccess);
